'use client'

import { ImageBanner } from './image'

export const ImageContainer = () => {
  return (
    <div className="relative hidden basis-1/2 lg:block">
      <ImageBanner className="absolute inset-0" />
    </div>
  )
}
